import type { ReactNode } from "react";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

type Props = {
  Icon: ReactNode;
  title?: string;
  subtitle?: string;
  Action?: ReactNode;
  compact?: boolean;
  className?: string;
};
const BodyEntry = ({
  Icon,
  title,
  subtitle,
  Action,
  compact,
  className,
}: Props) => (
  <div
    className={getClasses(
      styles["body-entry"],
      compact && styles["body-entry--compact"],
      className,
    )}
  >
    <div className={getClasses(styles["body-entry__icon"])}>{Icon}</div>
    <div className={styles["body-entry__content"]}>
      {(title || subtitle) && (
        <div>
          {title && (
            <span>
              {title}
              {title && subtitle && " | "}
            </span>
          )}
          {subtitle && (
            <span className={styles["body-entry__subtitle"]}>{subtitle}</span>
          )}
        </div>
      )}
      {Action}
    </div>
  </div>
);

export default BodyEntry;
